import type { Option } from '@branchjs/neo-components';
import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateAndroid = new ReduxAsyncAction<
  'UPDATE_ANDROID',
  string | Option | undefined,
  { android: string | Option | undefined }
>('UPDATE_ANDROID');

UpdateAndroid.registerRequest(async (android: string | Option | undefined) => {
  return { android };
});

export const UPDATE_ANDROID = UpdateAndroid.actionNamespaceConstants;
export const updateAndroid = UpdateAndroid.request;

export type UpdateAndroidResponseAction = Action<typeof UPDATE_ANDROID.response> & {
  data: { android: string | Option };
};
